// Consts
export const USER_CLEAR_USER = '[USER] Clear User';

export const clearUser = () => dispatch => dispatch({ type: USER_CLEAR_USER });
